
































import { Component, Vue } from 'vue-property-decorator';
import cCard from '@/components/default/Card.vue';
import countersRepository from '@/services/varia/countersRepository';
import notificationService from '@/services/notificationService';

@Component({
  components: {
    cCard,
  },
})
export default class CountersPage extends Vue {
  private counters: any[] = [];

  private mounted() {
    this.loadData();
  }

  private async loadData() {
    this.counters = (await countersRepository.get()).data;
  }

  private async reset(name: string) {
    try {
      if (confirm(`Bent u zeker dat u counter '${name}' wilt resetten?`)) {
        await countersRepository.reset(name);
        this.loadData();
        notificationService.saved();
      }
    } catch (err) {
      notificationService.showAxiosError(err);
    }
  }

  private async set(name: string, currentValue: number) {
    try {
      const value = prompt('Geef een nieuwe waarde in', '' + currentValue);
      if (value != null) {
        if (!isNaN(parseInt(value, 10))) {
          await countersRepository.set(name, parseInt(value, 10));
          this.loadData();
          notificationService.saved();
        } else {
          alert('Ongeldige waarde');
        }
      }
    } catch (err) {
      notificationService.showAxiosError(err);
    }
  }

}
